import { Site } from '@envato/foundation-types'
import * as React from 'react'

import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import * as styles from './filterDiscounts.module.css'

import FilterBoolean from '../filterBoolean'

interface IProps {
  discountsCount: number
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
}

const FilterDiscounts = ({
  discountsCount,
  locationParams,
  makeSearchLink
}: IProps) => {
  return (
    <div className={styles.root}>
      <FilterBoolean
        type="discounted_only"
        label="Yes"
        count={discountsCount}
        locationParams={locationParams}
        makeSearchLink={makeSearchLink}
      />
    </div>
  )
}

export default FilterDiscounts
